<template>
  <div id="srp-builder">
    <SRPBuilderNavbar 
      v-bind="{
        isBuilding: currentFlow.length > 0,
        currentFlow,
        flowTypes: componentTypes,
        selectedBrand
      }"
      @startOver="clearAll"
      @next="goToNextComponent"
      @previous="goToPreviousComponent"
    />
    <v-container fluid v-if="currentFlow.length">
      <v-layout row>
        <v-flex sm12>
          <SRPComponentSelector :componentType="currentFlow" :selectedBrand="selectedBrand"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="intro-block" v-else>
      <v-layout row>
        <v-flex xs8 sm6 md7 lg8 pl-4 pr-4>
          <h1>
            <span class="light">Dealer </span
            ><span class="heavy">Draft</span> SRP Builder
          </h1>
          <v-flex xs12 lg10>
            <p>
              At Sokal, we know that a good search results page can get you more leads even faster. Select which layouts, pricing, and call to actions best suit your site's needs. Just Build, Preview and take a screenshot of your new search results page with our personalized website builder.
            </p>
            <p>
              Note: images, colors, and brands are flexible with each site and can be tailored to your brand.
            </p>
            </v-flex>
            <v-form>
              <v-layout row>
                <v-flex xs10 md8 lg6>
                  <v-select
                  :items="brands"
                  attach
                  label="Choose Your Brand"
                  v-model="selectedBrand"
                  ></v-select>
                  <v-btn depressed @click="selectBrand">Start Building</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
        </v-flex>
        <v-flex xs4 sm6 md5 lg3 offset-lg1 pt-4>
          <v-img
            v-if="currentBrandPreviewImg"
            contain
            width="100%"
            :src="currentBrandPreviewImg"
            :alt="`${selectedBrand} Preview`">
          </v-img>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SRPBuilderNavbar from '@/components/SRPBuilderNavbar.vue'
import SRPComponentSelector from '@/components/SRPComponentSelector.vue'

export default {
  name: 'SRPBuilder',
  data() {
    return {
      selectedBrand: "None",
      brands: [
        "None",
        "Chevrolet",
        "CJDR",
        "Ford",
        "Honda",
        "Hyundai",
        "INFINITI",
        "Kia",
        "Lincoln",
        "Mazda",
        "Mitsubishi",
        "Nissan",
        "Toyota"
      ],
      componentTypes: ['Search Results', 'Pricing', 'Buttons'],
      currentFlow: ''
    };
  },
  computed: {
    ...mapState(['chosenComponents', 'chosenBrand']),
    currentComponent() {
      return this.componentTypes.find(component => component === this.currentFlow)
    },
    currentBrandPreviewImg() {
      if (this.selectedBrand && this.selectedBrand !== 'None') {
        return require(`../../static/images/branding_previews/${this.selectedBrand}.jpg`)
      }
      return null
    },
  },
  methods: {
    selectBrand() {
      if (!this.selectedBrand) {
        this.$store.commit("chooseBrand", "None");
      } else {
        this.$store.commit("chooseBrand", this.selectedBrand.toLowerCase());
      }
      this.startFlow()
    },
    goToNextComponent() {
      const next = this.componentTypes[this.componentTypes.indexOf(this.currentComponent) + 1]
      this.currentFlow = next
    },
    goToPreviousComponent() {
      const previous = this.componentTypes[this.componentTypes.indexOf(this.currentComponent) - 1]
      this.currentFlow = previous
    },
    startFlow() {
      this.currentFlow = this.componentTypes[0]
    },
    setInitialBrandSelection() {
      const chosen = this.brands.find(b => b.toLowerCase() === this.chosenBrand)
      if (chosen) return chosen
      return 'None'
    },
    clearAll() {
      this.currentFlow = ''
      this.$store.state.chosenComponents = [];
      this.$store.commit("chooseBrand", "None");
      this.selectedBrand = "None";
    }
  },
  watch: {
    currentFlow: function () {
      window.scrollTo(0,0)
    },
  },
  created() {
    this.selectedBrand = this.setInitialBrandSelection()
    if (this.$route.params.start_over && this.$route.params.start_over === true) {
      this.$store.state.chosenComponents = []
    }
    if (this.$route.params.refine && this.$route.params.refine === true) {
      this.currentFlow = this.componentTypes[2]
    }
  },
  mounted () {
    window.scrollTo(0, 0);
    document.getElementById('app').scrollIntoView();
  },
  components: {
    SRPBuilderNavbar,
    SRPComponentSelector,
  },
};
</script>

<style>
#srp-builder {
  min-height: calc(100vh - 36px);
}
.clear-btn {
  margin: 0;
}
#srp-builder .intro-block h1 {
  margin: 30px 0px 15px;
  font-weight: 500;
  font-size: 3.5rem;
}
#srp-builder .intro-block p {
  font-size: 16px;
}
#srp-builder .light {
  font-weight: 300;
}
#srp-builder .heavy {
  font-weight: 600;
}
#srp-builder .intro-block span {
  color: #006aff;
  font-family: futura-pt, "Avenir", Helvetica, Arial, sans-serif;
}
#srp-builder .intro-block button {
  margin-left: 0px;
  margin-top: 30px;
  background: #006aff;
  color: #fff;
  border: 2px solid #006aff;
  font-size: 16px;
  font-weight: 400;
  text-transform: capitalize;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
#srp-builder .intro-block button:hover {
  background: #fff;
  color: #006aff;
}
#srp-builder .v-btn--active:before,
#srp-builder .v-btn:hover:before,
#srp-builder .v-btn:focus:before {
  background-color: #fff;
}

#srp-builder .intro-block .v-select {
  margin-top: 30px;
  padding-top: 0;
}
</style>

<style scoped>
.visual-box {
  height: 60px;
  width: 60px;
  border: 2px solid #006aff;
  border-radius: 4px;
  margin: auto auto 20px;
  display: flex;
  color: #006aff;
  font-weight: 600;
  align-items: center;
  justify-content: center;
}
.component-visual {
  color: #006aff;
  margin-bottom: 30px;
  text-align: center;
}
</style>
